import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import { TabPanel } from './TabPanel';
import { TabTitle } from './TabTitle';
import styles from './Tabs.module.scss';
import { useTabs } from './useTabs';
import { TabsContext } from './useTabsContext';

export const Tabs = ({
  children = '',
  selectedIndex = '1',
  isCheckoutTab = false,
  className,
}) => {
  const animatedLineRef = useRef();
  const containerRef = useRef();
  const { activeTab, setActiveTab, isAnimating, setIsAnimating, animateLine } =
    useTabs({
      selectedIndex,
      animatedLineRef,
      containerRef,
    });

  /**
   * Memoize the context to prevent unecessary renders.
   */
  const memoizedContextValue = React.useMemo(
    () => ({
      activeTab,
      setActiveTab,
      animateLine,
      isAnimating,
      setIsAnimating,
      isCheckoutTab,
    }),
    [
      activeTab,
      setActiveTab,
      animateLine,
      isAnimating,
      setIsAnimating,
      isCheckoutTab,
    ],
  );

  const titles = children.filter(
    (child) => child && child.type.displayName === 'TabTitle',
  );
  const panels = children.filter(
    (child) => child && child.type.displayName === 'TabPanel',
  );

  return (
    <div className={`${styles.tabsWrapper} ${className}`}>
      <TabsContext.Provider value={memoizedContextValue}>
        <div className={styles.titlesWrapper}>
          <div
            className={`${styles.titleContainer} ${
              isCheckoutTab && styles.checkoutTab
            }}`}
            ref={containerRef}
          >
            {titles}
          </div>
          <div ref={animatedLineRef} className={styles.animatedLine} />
        </div>
        {panels}
      </TabsContext.Provider>
    </div>
  );
};

Tabs.Title = TabTitle;
Tabs.Panel = TabPanel;

Tabs.propTypes = {
  children: PropTypes.node,
  selectedIndex: PropTypes.string,
  isCheckoutTab: PropTypes.bool,
};
